<button mat-icon-button [matMenuTriggerFor]="jeopshipreasonoptsmenu">
    <fa-icon [icon]="iconMore"></fa-icon>
</button>
<mat-menu #jeopshipreasonoptsmenu="matMenu">
    <button mat-menu-item (click)="customerAlias()">Customer Alias</button>
    <button mat-menu-item (click)="cityAlias()">
        <span>City Alias</span>
    </button>
    <button *ngIf="!isMultiTripError" mat-menu-item (click)="previousTrip()">
        <span>View Previous Trip</span>
    </button>
    <button mat-menu-item (click)="navigateToOriginCriteria()">
        <span>Origin Criteria</span>
    </button>
    <button *ngIf="!isMultiTripError" mat-menu-item (click)="addOriginCriteria()">
        <span>Add to Origin Criteria</span>
    </button>
    <button mat-menu-item (click)="navigateToDestinationCriteria()">
        <span>Destination Criteria</span>
    </button>
    <button *ngIf="!isMultiTripError" mat-menu-item (click)="addDestinationCriteria()">
        <span>Add to Destination Criteria</span>
    </button>
    <button *ngIf="!isMultiTripError" mat-menu-item (click)="reapplyClms()">Reapply CLMs</button>
</mat-menu>
